import React from "react";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import { getImageLink, getImageAltText, getImageCaption } from "../../../utils/images";
import { decodeText } from "../../../utils/richText";

// "original" keeps the intrinsic ratio; anything else crops via CSS (object-fit),
// mirroring the FTL renderer's CSS-only cropping fallback (aspectRatio.ftl).
const imageStyle = (aspectRatio) =>
    aspectRatio && aspectRatio !== "original"
        ? { width: "100%", aspectRatio: aspectRatio.replace(":", " / "), objectFit: "cover" }
        : { maxWidth: "100%" };

// The standalone, authorable Image content component (the plain Image primitive next to it
// stays as the embedded building block for Hero, product detail, etc.).
const ImageComponent = ({ image, imageAltText, caption, aspectRatio, target }) => {
    const src = getImageLink(image);
    if (!src) return null;

    // Authored values win; the asset's own metadata from the Assets app is the default.
    const alt = decodeText(imageAltText || getImageAltText(image));
    const figcaption = decodeText(caption || getImageCaption(image));

    // mb-0: Bootstrap gives <figure> a 1rem bottom margin, which would add to the stack
    // spacing and make the image sit higher than its neighbours.
    return (
        <figure className="mb-0">
            <LinkWrapper linkNode={{ target }} renderChildren>
                <img src={src} alt={alt} style={imageStyle(aspectRatio)} />
            </LinkWrapper>
            {figcaption && <figcaption className="figure-caption mt-2">{figcaption}</figcaption>}
        </figure>
    );
};

export default ImageComponent;